export default "__VITE_ASSET__Bor7kaV___"